/**
 * Handles close banners
 * @module closeBanner
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

export const PLUGIN_NAME = 'closeBanner';

const closeBannerEventHandlers = () => {
  const closeBannerChild = $('.js-close-banner');
  const closeBannerParent = $('.js-close-parent');
  closeBannerChild.on('click', () => {
    closeBannerParent.hide();
  });
};
// $el trigger
export default function bannerCloseBtn() {
  const $el = $('.js-close-banner');
  closeBannerEventHandlers($el);
}

registerJQueryPlugin(PLUGIN_NAME, bannerCloseBtn);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/close-banner.js